import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { CREATIVE_LIBRARY_REPORT_ID } from 'modules/campaigns/modules/campaigns-reports/config/reports/creative-library/creativeLibraryReportId';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';

const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.CUSTOM_CREATIVE_NAME.field,
    FIELDS.APPROVAL_STATUS.field,
    FIELDS.ID.field,
    FIELDS.CONTENT.field,
    FIELDS.URL.field,
    FIELDS.BRANDING_TEXT.field,
    FIELDS.TYPE.field,
    FIELDS.AD_GROUPS_ASSIGNMENT.field,
    FIELDS.FORMAT.field,
    FIELDS.DIMENSIONS.field,
    FIELDS.CREATIVE_ORIENTATION.field,
    FIELDS.CREATE_TIME.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CREATIVE_LIBRARY_REPORT_ID, field));

export { defaultColumns };
